export default __webpack_public_path__ + "f83a8500d9479479fd1dd57772e2ebbd.png";